define('commons/device-location-map-configurator',['jquery', 'commons/toggle-selector', 'commons/feedback-button', 'commons/simple-multi-slider', 'utils/format', 'utils/icons'], function($, ToggleSelector, FeedbackButton, SimpleMultiSlider, format, icon) {

    var DeviceLocationMapConfigurator = function(map, options) {
        this.multiSlider = null;
        this.map = map;

        this.settings = {
                mode: "STATUS",
                thresholds: {
                    status: ["not_seen", "warn", "ko", "ok"],
                    // dBm values, preserve order please or the whole backend/Internet will be fu**ed up :(
                    rssi: {"bad":-145, "few":-140, "medium":-136, "good":-133, "excellent":-126}
                },
                minValue: {"rssi":-160},
                maxValue: {"rssi":-100},
                colors: ["BBBBBB", "FF4633", "FFAA24","F2F20C", "29CF6F","44F230"],
                showCloseButton: false,
                onCloseClicked: function(event){}
        };
        $.extend(this.settings, options);

        new ToggleSelector(".toggle-selector", {
            onItemSelected: $.proxy(function(event) {
                    var mode = event.target.id;
                    // set the new mode: "status" or "rssi"
                    this.switchMode(mode);
                    // update the DOM to add mode icons and their thresholds values
                    // Fill specific elements
                    this._fillMapMarkersConfigurator(mode);
                }, this)
        });
        
        // Create the feedback stuff
        new FeedbackButton("button#apply-btn", {
            onClick: $.proxy(function(event){
                var inputs = this.multiSlider.getValuesWithNames(); 
                for (var i=0 ; i < inputs.length; i++) {
                    this.updateThresholdValue(this.settings.mode, inputs[i].name, inputs[i].value);
                }
                this.switchMode(this.settings.mode);
                
                return true;
            },this)
        });
        
        if (!this.settings.showCloseButton) {
            $("#close-btn").hide();
        } else {
            $("#close-btn").click($.proxy(function(event) {
                this.settings.onCloseClicked(event);
            }, this));
        }
    };
    
    DeviceLocationMapConfigurator.prototype.switchMode = function(mode) {
        this.settings.mode = mode;
        for (var id in this.map.markers) {
            var marker = this.map.markers[id];
            marker.setIcon(this._getIcon(marker.markerInfo));
        }
    };
    
    DeviceLocationMapConfigurator.prototype._getIcon = function(markerInfo) {
        if (!markerInfo.type || markerInfo.type === "device") {
            var mode = this.settings.mode.toUpperCase();
            switch(mode) {
                case "STATUS":
                    return icon.device[mode + "_" + markerInfo.comStateString.toUpperCase()];
                case "RSSI":
                    return icon.device[mode + "_" + this.getStrengthFromValue("rssi", parseFloat(markerInfo.lastRssi)).toUpperCase() ];
                default:
                    throw "Invalid mode value: " + mode + ". Shall be one of : 'status', 'rssi'.";
            }
        } else {
            return this.map._getIcon(markerInfo);
        }
    };
    
    /**
     * Returns the strength from a signal info type.
     * @param type String - Could be one of: "rssi" (opts.thresholds values).
     * @param value Double - The signal value to retrieve the strength of.
     */
    DeviceLocationMapConfigurator.prototype.getStrengthFromValue = function(type, value) {
        var bestStrength = "no";
        for (var strength in this.settings.thresholds[type]) {
            if (value === null) {
                return "no";
            } else if (this.settings.thresholds[type][strength] <= value && 
                    (!this.settings.thresholds[type][bestStrength] || this.settings.thresholds[type][bestStrength] < this.settings.thresholds[type][strength])) {
                bestStrength = strength;
            }
        }
        return bestStrength;
    };
    
    /**
     * Updates the strength threshold value for a signal info type.
     * @param mode String - Could be one of: "rssi" (opts.thresholds values).
     * @param strength String - Could be one of : "excellent", "good", "medium", "few", "bad".
     * @param value Double - The signal value to retrieve the strength of.
     */
    DeviceLocationMapConfigurator.prototype.updateThresholdValue = function(mode, strength, value) {
        this.settings.thresholds[mode.toLowerCase()][strength] = value;
    };
    
    DeviceLocationMapConfigurator.prototype.refresh = function() {
        this._fillMapMarkersConfigurator(this.settings.mode);
        this.switchMode(this.settings.mode);
    };

    /**
     * Returns the thresholds numbers for a given mode. 
     * @param mode String - Could be one of: "rssi" (opts.thresholds values).
     */
    DeviceLocationMapConfigurator.prototype.getThresholdValues = function(mode) {
        var res = [];
        
        for (var strength in this.settings.thresholds[mode]){
            res.push(this.settings.thresholds[mode.toLowerCase()][strength]);
        }
        
        return res;
    };
    
    DeviceLocationMapConfigurator.prototype._fillMapMarkersConfigurator = function (mode) {
        mode = mode.toLowerCase();
        
        $(".mapmarkers-configurator button#apply-btn").hide();
        $("#thresholds-slider").hide();
        $(".mapmarkers-configurator ul").children().remove();
        $(".mapmarkers-configurator ul").append("<li><img src='/resources/img/mapmarkers/device_" + mode + "/no.png'>No signal</li>");
    
        if (this.multiSlider) {
            this.multiSlider.destroy();
            this.multiSlider = null;
        }
        
        if (this.settings.thresholds[mode].length) {
            for (var i = 0, length = this.settings.thresholds[mode].length ; i < length; i++) {
                $(".mapmarkers-configurator ul").append("<li><img src='/resources/img/mapmarkers/device_" + mode + "/"+  this.settings.thresholds[mode][i] + ".png'>" + format.capitaliseFirstLetter(this.settings.thresholds[mode][i]) +  "</li>");
            }
        }else{
            for(var strength in this.settings.thresholds[mode]){
                $(".mapmarkers-configurator ul").append("<li><img src='/resources/img/mapmarkers/device_" + mode + "/"+  strength + ".png'>" + format.capitaliseFirstLetter(strength) +  "</li>");
            }
            $("#thresholds-slider").show();
            this.multiSlider = new SimpleMultiSlider("#thresholds-slider",
                    this.getThresholdValues(mode), 
                    this.settings.colors,this.settings.minValue[mode], 
                    this.settings.maxValue[mode], 
                    {valuesNames:Object.keys(this.settings.thresholds[mode])} 
            );
            $(".mapmarkers-configurator button#apply-btn").show();
        }
    };
    
    return DeviceLocationMapConfigurator;
});

